import { useRouter } from 'next/router';
import { useRef } from 'react';
import type { RefObject } from 'react';

export function useIsChineseLanguage(): RefObject<boolean | null> {
  const router = useRouter();
  const isChineseLanguage = useRef(router.locale === 'zh' || router.locale === 'zh-tw');
  return isChineseLanguage;
}
